import {registerPlugin, type PluginListenerHandle} from '@capacitor/core';

export type AppUpdateInstallStatus =
  | 'unknown'
  | 'pending'
  | 'downloading'
  | 'downloaded'
  | 'installing'
  | 'installed'
  | 'failed'
  | 'canceled';

export type AppUpdateAvailability =
  | 'unknown'
  | 'notAvailable'
  | 'available'
  | 'developerTriggeredUpdateInProgress';

export interface AppUpdateState {
  availability: AppUpdateAvailability;
  flexibleUpdateAllowed: boolean;
  installStatus: AppUpdateInstallStatus;
  availableVersionCode?: number;
  failedUpdatePreconditions?: number[];
  bytesDownloaded?: number;
  totalBytesToDownload?: number;
  installErrorCode?: number;
}

export interface AppUpdatePlugin {
  getUpdateState(): Promise<AppUpdateState>;
  startFlexibleUpdate(): Promise<{accepted: boolean; resultCode: number}>;
  completeUpdate(): Promise<void>;
  openStoreListing(): Promise<void>;
  addListener(
    eventName: 'stateChange',
    listener: (state: AppUpdateState) => void,
  ): Promise<PluginListenerHandle>;
}

export const AppUpdate = registerPlugin<AppUpdatePlugin>('AppUpdate');
